import { createSlice, createAsyncThunk , current} from "@reduxjs/toolkit";

import { axiosBaseUrl } from '../../config/axios-configuration';

import SaveSentryLog from "../../helpers/sentry-log";

const axios = axiosBaseUrl();

export const GetShipments = createAsyncThunk(
 'shipment/getShipments',
  async (data, {rejectWithValue }) => {
    try {
      const {
        filters,
        skip,
        limit
      } = data;
      const response = await axios.get('/fba-shipments/get-fba-shipments', {
        params: {
          filters,
          skip,
          limit
        }
      });
      return response.data;
    } catch (err) {
      SaveSentryLog(new Error(err), 'GetShipmentsError');
      if (err.response && err.response.data) {
        return rejectWithValue({ 
          err: {
            message: err.response.data.message,
            status: err.response.status
          }
        });
      }
      return rejectWithValue({
        err: {
          message: 'Network Error',
          status: 502
        }
      });
    }
  }
);

export const GetShipmentItems = createAsyncThunk(
  'shipment/getShipmentsItems',
   async (data, { rejectWithValue }) => {
     try {
       const {
         filters,
         shipmentId,
         skip,
         limit
       } = data;
      
       const response = await axios.get('/fba-shipments/get-fba-shipment-items', {
         params: {
           shipmentId,
           filters,
           skip,
           limit
         }
       });
       return response.data;
     } catch (err) {
       SaveSentryLog(new Error(err), 'GetShipmentItemsError');
       if (err.response && err.response.data) {
         return rejectWithValue({ 
           err: {
             message: err.response.data.message,
             status: err.response.status
           }
         });
       }
       return rejectWithValue({
         err: {
           message: 'Network Error',
           status: 502
         }
       });
     }
   }
 );

export const ClaimShipmentCase = createAsyncThunk(
  'shipment/postClaimShipmentCase',
   async (data, { rejectWithValue }) => {
     try {
       const {
          storeId,
          shipmentId,
          status,
          caseId
       } = data;
      
       const response = await axios.post('/fba-shipments/claim-shipment-case', {
          storeId,
          shipmentId,
          caseId,
          status
       });
       return response.data;
     } catch (err) {
       SaveSentryLog(new Error(err), 'ClaimShipmentCaseError');
       if (err.response && err.response.data) {
         return rejectWithValue({ 
           err: {
             message: err.response.data.message,
             status: err.response.status
           }
         });
       }
       return rejectWithValue({
         err: {
           message: 'Network Error',
           status: 502
         }
       });
     }
   }
 );

 export const UploadInvoice = createAsyncThunk(
  'upload/inovoice',
   async (data, { rejectWithValue }) => {
     try {
       const {
          file,
          shipment
       } = data;

       const formData = new FormData();
       for (let i = 0 ; i < file.length ; i++) {
          formData.append('invoices', file[i]);
       }

       formData.append("shipment", JSON.stringify(shipment));
       const response = await axios.post('/fba-shipments/upload-invoice', formData);
       return response.data;
     } catch (err) {
       SaveSentryLog(new Error(err), 'UploadInvoiceError');
       if (err.response && err.response.data) {
         return rejectWithValue({ 
           err: {
             message: err.response.data.message,
             status: err.response.status
           }
         });
       }
       return rejectWithValue({
         err: {
           message: 'Network Error',
           status: 502
         }
       });
     }
   }
 );

export const getShipment = (state) => {
  return state['shipment'].invoiceToUpload;
}

const shipment = createSlice({
    name: 'shipment',
    initialState: {
      error: '',
      loading: '',
      message: '',
      success: false,
      total: 0,
      shipments: [],
      shipmentItems: [],
      shipmentItemsTotal: 0,
      invoiceUploaded: false,
      invoiceToUpload: {}
    },
    reducers: {
      SetShipmentState(state, {payload: {field, value} }) {
        state[field] = value;
      }
    },
    extraReducers: {
      [GetShipments.pending]: (state, action) => ({
        ...state,
        loading: true
      }),
      [GetShipments.fulfilled]: (state, action) => ({
        ...state,
        success: true,
        loading: false,
        shipments: action.payload.fbaShipments,
        total: action.payload.total
      }),
      [GetShipments.rejected]: (state, action) => ({
        ...state,
        shipments: [],
        shipmentItems: [],
        total: 0,
        shipmentItemsTotal: 0,
        success: false,
        loading: false,
        error: action.payload.err.message
      }),
      [GetShipmentItems.pending]: (state, action) => ({
        ...state,
        loading: true
      }),
      [GetShipmentItems.fulfilled]: (state, action) => ({
        ...state,
        success: true,
        loading: false,
        message: action.payload.message,
        shipmentItems: action.payload.fbaShipmentItems,
        shipmentItemsTotal: action.payload.total
      }),
      [GetShipmentItems.rejected]: (state, action) => ({
        ...state,
        shipmentItems: [],
        shipmentItemsTotal: 0,
        success: false,
        loading: false,
        error: action.payload.err.message
      }),
      [ClaimShipmentCase.pending]: (state, action) => ({
        ...state,
        loading: true
      }),
      [ClaimShipmentCase.fulfilled]: (state, action) => ({
        ...state,
        success: true,
        loading: false,
        message: action.payload.message,
      }),
      [ClaimShipmentCase.rejected]: (state, action) => ({
        ...state,
        success: false,
        loading: false,
        error: action.payload.err.message
      }),
      [UploadInvoice.pending]: (state, action) => ({
        ...state,
        loading: true,
        invoiceUploaded: false,
      }),
      [UploadInvoice.fulfilled]: (state, action) => ({
        ...state,
        success: true,
        invoiceUploaded: true,
        message: action.payload.message,
        loading: false,
      }),
      [UploadInvoice.rejected]: (state, action) => ({
        ...state,
        success: false,
        loading: false,
        invoiceUploaded: false,
        error: action.payload.err.message
      }),
    }
  });
  
  const { reducer, actions } = shipment;

  export const { SetShipmentState, GetShipmentState } = actions;

  export default reducer;
